/* ZAIVA sections JS — externalizado 11-jun-2026. defer. Las secciones encolan en window.ZQ y aqui se procesan. */
window.ZJS=window.ZJS||{};

/* ── bestsellers (cfg) ── */
ZJS.bestsellers=function(SID){
var grid = document.getElementById('zvp-grid-'+SID);
  if(!grid) return;
  var LIMIT = 4;

  function moneyFmt(cents){
    return '$'+(cents/100).toLocaleString('es-MX',{minimumFractionDigits:0,maximumFractionDigits:0});
  }

  function renderCard(p){
    var img = (p.images && p.images[0]) ? (typeof p.images[0]==='string' ? p.images[0] : (p.images[0].src || p.images[0])) : (p.image || '');
    if(typeof img === 'object' && img && img.src) img = img.src;
    var priceCents = p.price || (p.variants && p.variants[0] && parseFloat(p.variants[0].price)*100) || 0;
    var sold = p.sold_count || (Math.floor((p.id || 1) * 0.7) % 250 + 30);
    var rating = p.rating || 5;
    var reviewCount = p.review_count || (((p.id || 1) % 40) + 8);
    return ''+
      '<a class="zvp-card" href="/products/'+p.handle+'">'+
        '<div class="zvp-img">'+ (p.is_premium ? '<div class="zaiva-card-badges"><span class="zpb zpb-sm zpb-premium">PREMIUM</span></div>' : '') +
          (img ? '<img src="'+img+'" alt="'+(p.title||'').replace(/"/g,'')+'" loading="lazy">' : '')+
        '</div>'+
        '<div class="zvp-stars">'+
          '★★★★★ '+
          '<span class="zvp-cnt">('+reviewCount+')</span>'+
        '</div>'+
        '<div class="zvp-name">'+p.title+'</div>'+
        '<div class="zvp-price"><b>'+moneyFmt(priceCents)+'</b> / pz</div>'+
        '<div class="zvp-sold">+<b>'+sold+'</b> vendidas este mes</div>'+
      '</a>';
  }

  function paintGrid(products){
    if(!products || !products.length) return;
    grid.innerHTML = products.slice(0, LIMIT).map(renderCard).join('');
  }

  /* ─── Prioridad 1: Visitados recientemente (localStorage) ─── */
  function tryRecent(){
    try {
      var arr = JSON.parse(localStorage.getItem('zaiva_recent_products') || '[]');
      // Excluir el producto actual si estamos en una PDP
      var currentHandle = window.location.pathname.indexOf('/products/') === 0
        ? window.location.pathname.split('/')[2] : null;
      arr = arr.filter(function(p){ return p.handle !== currentHandle; });
      if(arr.length >= LIMIT){
        paintGrid(arr.map(function(p){
          return { handle: p.handle, title: p.title, image: p.image, price: p.price, id: p.id };
        }));
        return true;
      }
    } catch(e){}
    return false;
  }

  /* ─── Prioridad 2: Colección "mas-vendidos" o aleatorios ─── */
  function tryStore(){
    // Intentar primero la colección "mas-vendidos"
    fetch('/collections/mas-vendidos/products.json?limit=20')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(d){
        if(d.products && d.products.length >= 1){
          paintGrid(d.products.slice(0, LIMIT));
          return Promise.reject('done');
        }
        throw 'fallback';
      })
      .catch(function(err){
        if(err === 'done') return;
        // Fallback: todos los productos shuffled
        fetch('/products.json?limit=30')
          .then(function(r){ return r.json(); })
          .then(function(d){
            var prods = d.products || [];
            if(prods.length >= 1){
              // Shuffle
              prods.sort(function(){ return Math.random() - 0.5; });
              paintGrid(prods.slice(0, LIMIT));
            }
            // Si vacío, deja el HTML estático (fallback total)
          })
          .catch(function(){});
      });
  }

  // Ejecutar tras pequeño delay para que localStorage tenga tiempo de cargar
  setTimeout(function(){
    if(!tryRecent()){
      tryStore();
    }
  }, 200);
};

/* ── float-cart ── */
try{
(function(){
  // No mostrar en página /cart
  if(window.location.pathname === '/cart') return;

  var bar   = document.getElementById('zaiva-fc');
  var badge = document.getElementById('zaiva-fc-badge');
  var total = document.getElementById('zaiva-fc-total');
  var sub   = document.getElementById('zaiva-fc-sub');
  var pw    = document.getElementById('zaiva-fc-pw');
  var pf    = document.getElementById('zaiva-fc-pf');
  if(!bar) return;

  var TIERS = [
    {min:1999, pct:5,  label:'5% de descuento'},
    {min:3999, pct:10, label:'10% de descuento'},
    {min:6999, pct:15, label:'15% de descuento'},
    {min:9999, pct:20, label:'20% de descuento'},
  ];
  var MAX = TIERS[TIERS.length-1].min;

  function fmt(n){ return '$'+Math.round(n).toLocaleString('es-MX',{maximumFractionDigits:0}); }

  function render(cart){
    var t = cart.total_price / 100;
    var count = cart.item_count;

    if(count === 0){
      bar.style.display = 'none';
      return;
    }

    // Siempre visible con items
    bar.style.display = 'flex';
    badge.textContent = count;

    // Progress bar hacia siguiente tier
    if(pf) pf.style.width = Math.min(100, (t / MAX) * 100) + '%';

    var next = null;
    for(var i = 0; i < TIERS.length; i++){
      if(t < TIERS[i].min){ next = TIERS[i]; break; }
    }

    total.textContent = fmt(t) + ' en tu carrito';

    /* Mensaje secuencial: PRIMER goal = envío gratis $999, luego descuentos por volumen */
    var FS = 999;
    if(t < FS){
      sub.textContent = 'Te falta ' + fmt(FS - t) + ' para 🚚 ENVÍO GRATIS';
    } else if(!next){
      sub.textContent = '🎉 ¡Envío gratis + 20% de descuento activos!';
    } else {
      sub.textContent = '✓ Envío gratis · Te falta ' + fmt(next.min - t) + ' para ' + next.label;
    }
  }

  function load(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(){});
  }

  // Escuchar eventos de carrito de Vogal
  document.addEventListener('cart:updated', load);
  document.addEventListener('cart:refresh', load);
  document.addEventListener('cart:add', load);

  // Cargar al iniciar (con pequeño delay para que Vogal inicialice)
  setTimeout(load, 800);

  /* ── Click: abrir cart drawer de Vogal, no navegar ── */
  function openCartDrawer() {
    // 1. Vogal cart-drawer custom element
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // 2. Vogal link .cartOpen (toggle nativo)
    var toggle = document.querySelector('a.cartOpen, .cartOpen, [data-cart-toggle]');
    if (toggle) {
      toggle.click();
      return;
    }
    // 3. Header cart icon fallback
    var hdrCart = document.querySelector('.hdicon[href*="cart"], a[href="/cart"]');
    if (hdrCart) {
      hdrCart.click();
      return;
    }
    // 4. Último recurso: navegar
    window.location.href = '/cart';
  }

  bar.addEventListener('click', openCartDrawer);
  bar.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') openCartDrawer();
  });
})();
}catch(e){console.error('zjs:float-cart',e)}

/* ── live-feed (cfg) ── */
ZJS.livefeed=function(sid,interval){
var container = document.getElementById('zlf-items-' + sid);
  if(!container) return;

  var POOL = [
    {i:'K', n:'Karla M. — Monterrey',     p:'Pidió 20 Playeras Oversize · 6 colores',           t:'3 min'},
    {i:'D', n:'Daniela R. — CDMX',        p:'Pidió 12 Conjuntos 2 pzs — reorden mensual',        t:'18 min'},
    {i:'L', n:'Lupita V. — Guadalajara',  p:'Reorden 15 Vestidos Floreados · 4ta compra',        t:'41 min'},
    {i:'A', n:'Ana G. — Puebla',          p:'Pidió 8 Vestidos Cortos en negro y beige',           t:'1 hr'},
    {i:'S', n:'Sofía H. — Tijuana',       p:'Pidió 10 Pantalones de Mezclilla rectos',            t:'1.5 hrs'},
    {i:'V', n:'Valeria C. — León',        p:'Pidió 15 Blusas sin Mangas · primer pedido',         t:'2 hrs'},
    {i:'R', n:'Rosa M. — Veracruz',       p:'Pidió 6 Palazzo en 3 colores diferentes',            t:'2.5 hrs'},
    {i:'B', n:'Brenda L. — Querétaro',    p:'10 Crop Tops — ya los vendió todos',                 t:'3 hrs'},
    {i:'J', n:'Jessica T. — Cancún',      p:'Pidió 8 Camisas Manga Larga · tallas M y L',        t:'4 hrs'},
    {i:'M', n:'Mónica P. — San Luis',     p:'Pidió 12 Conjuntos De Falda Y Blusa',               t:'5 hrs'},
    {i:'P', n:'Paty N. — Mérida',         p:'Reorden de 20 Playeras Estampadas · 3er pedido',    t:'6 hrs'},
    {i:'G', n:'Gloria S. — Chihuahua',    p:'Pidió 8 Jumpers — primer pedido 🎉',                t:'8 hrs'},
  ];

  var items = container.querySelectorAll('.zlf-item');
  if(items.length === 0) return;

  var nextIdx = items.length % POOL.length;
  var rotatePos = 0;

  function html(e) {
    return '<div class="zlf-avatar">' + e.i + '</div>' +
           '<div class="zlf-info"><b>' + e.n + '</b><span>' + e.p + '</span></div>' +
           '<div class="zlf-time">' + e.t + '</div>';
  }

  function rotate() {
    var pos = rotatePos % items.length;
    rotatePos++;
    var item = items[pos];
    item.style.opacity = '0';
    setTimeout(function() {
      item.innerHTML = html(POOL[nextIdx % POOL.length]);
      nextIdx++;
      item.style.opacity = '1';
    }, 380);
  }

  
  setTimeout(function(){
    setInterval(rotate, interval * 1000);
  }, 3000);
};

/* ── random-products (cfg) ── */
ZJS.randomprods=function(SID,BATCH,CURRENT){
var grid=document.getElementById('zrp-grid-'+SID);
  var moreBtn=document.getElementById('zrp-more-'+SID);
  var pool=[], shown=0;

  function fmt(n){ return '$'+Math.round(n).toLocaleString('es-MX'); }
  function shuffle(a){ for(var i=a.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=a[i]; a[i]=a[j]; a[j]=t; } return a; }

  function img400(src){ if(!src) return ''; return src + (src.indexOf('?')>=0 ? '&' : '?') + 'width=400'; }

  var priceMode='dollars';
  function imgsrc(p){ var s=p.featured_image || (p.images&&p.images[0]); if(!s) return ''; if(typeof s==='object') s=s.src||''; return s; }
  function vprice(v){ if(!v) return 0; return priceMode==='cents' ? (v.price/100) : parseFloat(v.price); }
  function card(p){
    var v=null; for(var i=0;i<p.variants.length;i++){ if(p.variants[i].available){ v=p.variants[i]; break; } }
    var price=vprice(v||(p.variants&&p.variants[0]));
    var src=imgsrc(p);
    var el=document.createElement('div'); el.className='zrp-card';
    el.innerHTML =
      '<a class="zrp-imglink" href="/products/'+p.handle+'">'+(src?'<img src="'+img400(src)+'" alt="" loading="lazy">':'')+'</a>'+
      '<div class="zrp-body">'+
        '<a class="zrp-title" href="/products/'+p.handle+'">'+p.title+'</a>'+
        '<div class="zrp-price">'+fmt(price)+' <span>/ pieza</span></div>'+
        (v?'<button class="zrp-add" data-vid="'+v.id+'">Agregar</button>':'<button class="zrp-add" disabled>Agotado</button>')+
      '</div>';
    var btn=el.querySelector('.zrp-add[data-vid]');
    if(btn) btn.addEventListener('click', function(){ quickAdd(btn); });
    return el;
  }

  function quickAdd(btn){
    var id=parseInt(btn.getAttribute('data-vid'),10);
    var old=btn.textContent; btn.disabled=true; btn.textContent='Agregando…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
      .then(function(res){
        if(!res.ok){ btn.textContent='Sin stock'; setTimeout(function(){ btn.disabled=false; btn.textContent=old; },1600); return; }
        btn.classList.add('added'); btn.textContent='✓ Agregado';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:add'));
        setTimeout(function(){ btn.disabled=false; btn.classList.remove('added'); btn.textContent=old; },1800);
      })
      .catch(function(){ btn.disabled=false; btn.textContent=old; });
  }

  function renderMore(){
    var slice=pool.slice(shown, shown+BATCH);
    var frag=document.createDocumentFragment();
    slice.forEach(function(p){ frag.appendChild(card(p)); });
    grid.appendChild(frag);
    shown+=slice.length;
    moreBtn.style.display = (shown<pool.length) ? '' : 'none';
  }

  function start(list){
    pool=list.filter(function(p){ if(p.id===CURRENT) return false; return (p.variants||[]).some(function(v){ return v.available; }); });
    if(pool.length===0){ grid.innerHTML='<div class="zrp-empty">No hay sugerencias disponibles.</div>'; return; }
    renderMore();
  }
  function loadRandom(){
    priceMode='dollars';
    fetch('/products.json?limit=250').then(function(r){ return r.json(); }).then(function(d){
      var list=(d.products||[]).slice(); shuffle(list); start(list);
    }).catch(function(){ grid.innerHTML='<div class="zrp-empty">No se pudieron cargar sugerencias.</div>'; });
  }
  // 1) Recomendaciones reales de Shopify (comportamiento de la tienda = lo más visto/popular)
  fetch('/recommendations/products.json?product_id='+CURRENT+'&intent=related&limit=20')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var recs=(d.products||[]).filter(function(p){ return (p.variants||[]).some(function(v){ return v.available; }); });
      if(recs.length>=4){ priceMode='cents'; start(recs); }   // recs ya vienen ordenados por relevancia
      else { loadRandom(); }
    })
    .catch(loadRandom);

  moreBtn.addEventListener('click', function(){ renderMore(); var all=document.getElementById('zrp-all-'+SID); if(all) all.style.display='inline-block'; });
};

/* ── resellers-block ── */
try{
(function(){
  function isMobile(){ return window.innerWidth < 768; }
  document.querySelectorAll('.zrb-sec .zrb-card').forEach(function(card){
    card.addEventListener('click', function(){
      if(!isMobile()) return;
      var wasOpen = card.classList.contains('zrb-open');
      // Close all
      document.querySelectorAll('.zrb-sec .zrb-card.zrb-open').forEach(function(c){
        c.classList.remove('zrb-open');
      });
      // Open clicked (if was not already open)
      if(!wasOpen) card.classList.add('zrb-open');
    });
  });
})();
}catch(e){console.error('zjs:resellers-block',e)}

/* ── ticker ── */
try{
(function(){
  var wrap  = document.getElementById('zt-wrap');
  var inner = document.getElementById('zt-inner');
  if(!inner) return;
  var pos = 0, half = inner.scrollWidth / 2, paused = false;
  wrap.addEventListener('mouseenter', function(){ paused = true; });
  wrap.addEventListener('mouseleave', function(){ paused = false; });
  (function tick(){
    if(!paused){ pos -= 0.6; if(Math.abs(pos) >= half) pos = 0; inner.style.transform = 'translateX('+pos+'px)'; }
    requestAnimationFrame(tick);
  })();
})();
}catch(e){console.error('zjs:ticker',e)}

/* runner */
(window.ZQ||[]).forEach(function(q){try{ZJS[q[0]].apply(null,q.slice(1))}catch(e){console.error('zq',q[0],e)}});
window.ZQ={push:function(q){try{ZJS[q[0]].apply(null,q.slice(1))}catch(e){console.error('zq',q[0],e)}}};

/* ── brand-proof video lazy (autoplay solo al entrar al viewport) ── */
try{
(function(){
  var vids=document.querySelectorAll('video.zbp-lazy');
  if(!vids.length) return;
  function start(v){
    var s=v.querySelector('source[data-src]');
    if(s && !s.src){ s.src=s.getAttribute('data-src'); v.load(); }
    var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
  }
  if(!('IntersectionObserver' in window)){ vids.forEach(start); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ start(e.target); io.unobserve(e.target); } });
  },{rootMargin:'250px'});
  vids.forEach(function(v){ io.observe(v); });
})();
}catch(e){console.error('zjs:zbp-lazy',e)}

